import type { AxiosError } from 'axios';

export const isNotFoundError = (error: unknown): boolean =>
  (error as AxiosError | null)?.status === 404;

export const isInvalidIdError = (error: unknown): boolean =>
  (error as AxiosError | null)?.status === 422;
